import yearsIce from "../../../../common/iceMapLayerYears.json";
import years from "../../../../common/seaMapLayerYears.json";
/**
 * National land survey of Finland (NLS) backgound map layer
 */
export var NLSBackgroundMap;
(function (NLSBackgroundMap) {
    NLSBackgroundMap["TopographicMap"] = "maastokartta";
    NLSBackgroundMap["BackgroundMap"] = "taustakartta";
    NLSBackgroundMap["Orthophotos"] = "ortokuva";
})(NLSBackgroundMap || (NLSBackgroundMap = {}));
export class Settings {
    eventListerners = [];
    year;
    isLoading;
    backgroundMap;
    zoom;
    mapCenter;
    layerOpacity;
    constructor({ year, backgroundMap, zoom, mapCenter, opacity, }) {
        // Initial default values, if there no config in URL
        this.year = -6000;
        this.isLoading = false;
        this.backgroundMap = NLSBackgroundMap.BackgroundMap;
        this.zoom = 3;
        this.mapCenter = [414553.6179, 6948916.8145]; // Center area of Finland
        this.layerOpacity = 1;
        // Validate and set config from URL
        if (year !== undefined && this.getSupportedSeaYears().includes(year)) {
            this.year = year;
        }
        if (backgroundMap &&
            Object.values(NLSBackgroundMap).includes(backgroundMap)) {
            this.backgroundMap = backgroundMap;
        }
        if (zoom !== undefined && zoom >= 0) {
            this.zoom = zoom;
        }
        if (mapCenter && mapCenter.length === 2) {
            this.mapCenter = mapCenter;
        }
        if (opacity !== undefined && opacity >= 0 && opacity <= 1) {
            this.layerOpacity = opacity;
        }
    }
    getZoom() {
        return this.zoom;
    }
    setZoom(zoom) {
        if (this.zoom === zoom) {
            return;
        }
        this.zoom = zoom;
        this.eventListerners.forEach((listerner) => {
            listerner.onZoomChange?.(this.zoom);
        });
    }
    getMapCenter() {
        return this.mapCenter;
    }
    setMapCenter(mapCenter) {
        if (this.mapCenter[0] === mapCenter[0] &&
            this.mapCenter[1] === mapCenter[1]) {
            return;
        }
        this.mapCenter = mapCenter;
        this.eventListerners.forEach((listerner) => {
            listerner.onMapCenterChange?.(this.mapCenter);
        });
    }
    getSupportedSeaYears() {
        return years;
    }
    getSupportedIceYears() {
        return yearsIce;
    }
    getYear() {
        return this.year;
    }
    getIsLoading() {
        return this.isLoading;
    }
    setYear(year) {
        if (this.year === year) {
            return;
        }
        this.year = year;
        this.eventListerners.forEach((listerner) => {
            listerner.onYearChange?.(year);
        });
    }
    setIsLoading(isLoading) {
        if (this.isLoading === isLoading) {
            return;
        }
        this.isLoading = isLoading;
        this.eventListerners.forEach((listerner) => {
            listerner.onLoadingStatusChange?.(isLoading);
        });
    }
    setBackgroundMap(backgroundMap) {
        if (this.backgroundMap === backgroundMap) {
            return;
        }
        this.backgroundMap = backgroundMap;
        this.eventListerners.forEach((listerner) => {
            listerner.onBackgroundMapChange?.(backgroundMap);
        });
    }
    getBackgroundMap() {
        return this.backgroundMap;
    }
    setLayerOpacity(layerOpacity) {
        if (this.layerOpacity === layerOpacity) {
            return;
        }
        this.layerOpacity = layerOpacity;
        this.eventListerners.forEach((listerner) => {
            listerner.onLayerOpacityChange?.(layerOpacity);
        });
    }
    getLayerOpacity() {
        return this.layerOpacity;
    }
    addEventListerner(listener) {
        this.eventListerners.push(listener);
    }
}
